/**
 * Affected-road row
 *
 * Single added affected-road entry: location (bold) + optional description
 * (muted) + a remove action.
 */
import { memo } from 'react';
import { ActionIcon, Group, Paper, Stack, Text, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ICON_SIZE_SM } from '@/constants/ui';

import type { ObstructionAffectedRoadInput } from '../../../types';

import styles from '../StepAffectedRoads.module.css';

interface AffectedRoadRowProps {
  item: ObstructionAffectedRoadInput;
  index: number;
  isLoading: boolean;
  onRemove: (index: number) => void;
}

export const AffectedRoadRow = memo(function AffectedRoadRow({
  item,
  index,
  isLoading,
  onRemove,
}: AffectedRoadRowProps) {
  const { t } = useTranslation();

  return (
    <Paper withBorder p="sm" radius="md" className={styles.row}>
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={2} className={styles.rowContent}>
          <Text size="sm" fw={600}>
            {item.location}
          </Text>
          {item.description && (
            <Text size="xs" c="dimmed">
              {item.description}
            </Text>
          )}
        </Stack>
        <Tooltip label={t('obstructions.wizard.affectedRoads.remove')}>
          <ActionIcon
            variant="subtle"
            color="red"
            disabled={isLoading}
            onClick={() => onRemove(index)}
            aria-label={t('obstructions.wizard.affectedRoads.remove')}
          >
            <IconTrash size={ICON_SIZE_SM} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Paper>
  );
});
